const PropertyUtils = {
  getStatusLabel(status) {
    const labels = {
      "Accepting Proxy": "Active Auctions",
      "Sold": "Sold",
      "Canceled": "Canceled",
      "Pre ForeClosure": "Pre-Foreclosure"
    };

    return labels[status] || status || "Unknown";
  },

  getStatusClass(status) {
    if (!status) return "status-default";

    const normalized = status.toLowerCase();

    if (normalized.includes("accepting")) return "status-accepting";
    if (normalized.includes("pre")) return "status-pre";
    if (normalized.includes("sold")) return "status-sold";
    if (normalized.includes("cancel")) return "status-canceled";

    return "status-default";
  },

  formatDate(dateValue) {
    if (!dateValue) return "N/A";

    const date = new Date(dateValue + "T00:00:00");

    if (Number.isNaN(date.getTime())) return dateValue;

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  },

  formatMoney(value) {
    if (!value) return "N/A";

    const cleanValue = String(value).replace(/,/g, "");
    const number = Number(cleanValue);

    if (Number.isNaN(number)) return value;

    return "$" + number.toLocaleString();
  }
};